import { RouteObject } from 'react-router-dom';
import Dashboard from '../pages/User/Dashboard/Index';
import PrivateRoute from './privateRoute';
import PrivateLayout from '../pages/Layouts/PrivateLayout/Index';
import Business from '../pages/User/Business/Index';
import Settings from '../pages/User/Settings/Index';
import Billing from '../pages/User/Billing/Index';
import Profile from '../pages/User/Profile/Index';
import Shopping from '../pages/User/Shopping/Index';
import ProductShow from '../pages/User/Shopping/Product/Show/Index';
import CartPage from '../pages/User/Shopping/Cart/Index';
import CreateBusiness from '../pages/User/Business/Create/Index';
import CheckoutPage from '../pages/User/Shopping/Checkout/Index';
import ViewOrders from '../pages/User/Orders/View/Index';
import OrdersPage from '../pages/User/Orders/Index';
import OnboardingRoute from './onboardingRoute';
import ViewBusiness from '../pages/User/Business/View/Index';


const privateRoutes: RouteObject[] = [
    {
        path: '/user',
        element: <PrivateLayout />,
        children: [
            {
                path: 'dashboard',
                element: (
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                ),
            },
            {
                path: 'businesses',
                element: (
                    <PrivateRoute>
                        <Business />
                    </PrivateRoute>
                ),
            },
            {
                path: 'businesses/:id',
                element: (
                    <PrivateRoute>
                        <ViewBusiness />
                    </PrivateRoute>
                ),
            },
            {
                path: 'businesses/create',
                element: (
                    <PrivateRoute>
                        <CreateBusiness />
                    </PrivateRoute>
                ),
            },
            {
                path: 'settings',
                element: (
                    <PrivateRoute>
                        <Settings />
                    </PrivateRoute>
                ),
            },
            {
                path: 'billing',
                element: (
                    <PrivateRoute>
                        <Billing />
                    </PrivateRoute>
                ),
            },
            {
                path: 'profile',
                element: (
                    <PrivateRoute>
                        <Profile />
                    </PrivateRoute>
                ),
            },
            {
                path: 'shop',
                element: (
                    <PrivateRoute>
                        <Shopping />
                    </PrivateRoute>
                ),
            },
            {
                path: 'cart',
                element: (
                    <PrivateRoute>
                        <CartPage />
                    </PrivateRoute>
                ),
            },
            {
                path: 'checkout',
                element: (
                    <PrivateRoute>
                        <CheckoutPage />
                    </PrivateRoute>
                ),
            },
            {
                path: 'orders',
                element: (
                    <PrivateRoute>
                        <OrdersPage />
                    </PrivateRoute>
                ),
            },
            {
                path: 'orders/:orderId',
                element: (
                    <PrivateRoute>
                        <ViewOrders />
                    </PrivateRoute>
                ),
            },
            {
                path: 'shop/:slug',
                element: (
                    <PrivateRoute>
                        <ProductShow />
                    </PrivateRoute>
                ),
            },
        ],
    },
];

export default privateRoutes